import React, { Component } from "react";

class ConfirmVotePanel extends Component {
  state = {};
  render() {
    return (
      <div
        className={
          this.props.voteCount === 3
            ? "color-switcher animated visible danger"
            : "color-switcher animated visible"
        }
      >
        <div>
          <p>Tienes {this.props.votosDisponibles} votos disponibles</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.onOpenModal}
            disabled={this.props.voteCount === 0}
          >
            {/* disabled="true" Para deshabilitar cuando termine votacion
          > */}
            Enviar votos
          </button>
        </div>
      </div>
    );
  }
}

export default ConfirmVotePanel;
